import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  HeadingStyled,
  RoleStatus,
  SpanStyled,
  TextStyled,
} from "../../../../components/styled/Elements";
import { useTranslation } from "react-i18next";
import {
  NavSidebarWrapper,
  ProfileBannerWrapper,
  ProfileContainer,
  ProfileContent,
  ProfileWrapper,
  PropertiesStatusWrapper,
  SocialWrappper,
  UserProfileContentWrapper,
} from "../styled";
import { tabsArrayList } from "../TabsArray";
import { Link, useNavigate } from "react-router-dom";
import BannerImage from "../components/BannerImage";
import ProfileImageUpload from "../components/ProfileImageUpload";
import {
  ProfileSidebarList,
  SocialProfile,
  specializationDropdownList,
} from "../../../../helpers/webConstants";
import {
  AvatarPlaceholder,
  Facebook,
  FalLogo,
  Globe,
  Instagram,
  Linkedin,
  Mosoq,
  One,
  ProfileImg,
  Website,
  XSocial,
  Youtube,
} from "../../../../components/styled/AllImages";
import { UserProfileLogos } from "../../../../helpers/dummyConstants";
import { Col, Row } from "react-bootstrap";
import ServicesCities from "../../../../components/profile/ServicesCities";
import ProfileContact from "../../../../components/profile/contact/ProfileContact";
import LookingFor from "../../../../components/profile/lookingForBanner/LookingForBanner";
import { SmBanner } from "../../../../components/profile/lookingForBanner/styled";
import PopertiesListing from "../properties/popertiesListing";
import LeadFormMobile from "../../enquire/lead-form/LeadFormMobile";
import CustomTooltip from "../../../../components/common/dropdowns/CustomTooltip";
import ProfileSkeleton from "../../../../components/profile/PorfileSkeleton";
import AuthApi from "../../../../services/api/authApi";
import { toast } from "react-toastify";
import LookingForListing from "../lookingForListing/LookingForListings";
import InquiryStatsBanner from "../../../../components/profile/inquiryStatsBanner/InquiryStatsBanner";

import { resolveMediaUrl } from "../../../../utils/mediaUrl";

const MyProfile = () => {
  const { t } = useTranslation();
  const sidebarRef = useRef();
  const [userProfile, setUserProfile] = useState({});
  const [showAll, setShowAll] = useState(false);
  const [showAllLookingFor, setShowAllLookingFor] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [notFound, setNotFound] = useState(false);
  const [showInquiryForm, setShowInquiryForm] = useState(false);
  const [isDesktop, setIsDesktop] = useState(window.innerWidth < 767);
  const navigate = useNavigate();

  useEffect(() => {
    const handleResize = () => setIsDesktop(window.innerWidth < 767);
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const fetchUserProfile = async () => {
    try {
      setIsLoading(true);
      const response = await AuthApi.getAuthenticatedUser();

      if (response.code === 200) {
        setUserProfile(response.data);
      }
      if (response.code === 204) {
        setNotFound(true);
      }
      if (response.code === 100) {
        toast.error(response.message);
      }
    } catch (error) {
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchUserProfile();
  }, []);

  return (
    <>
      {isLoading ? (
        <ProfileSkeleton />
      ) : notFound ? (
        <Box className="d-flex justify-content-center align-items-center h-50">
          <SpanStyled color="var(--text2)" size="30px">
            {t("profile_not_found")}
          </SpanStyled>
        </Box>
      ) : (
        <ProfileWrapper>
          <ProfileBannerWrapper>
            <BannerImage username={userProfile?.username} />
            <UserProfileContentWrapper>
              <Row>
                <Col md={12} lg={7} className="userProfileDetailView">
                  <Box className="userProfileAvatar">
                    <img
                      src={
                        userProfile?.profile
                          ? resolveMediaUrl(userProfile?.profile)
                          : AvatarPlaceholder
                      }
                      alt="Profile Image"
                      className="rounded-circle"
                    />
                  </Box>
                  <Box className="userProfileDetailAbout">
                    <HeadingStyled size="24px" weight={"bold"} lh="1">
                      {userProfile?.name}
                    </HeadingStyled>
                    <Box className="peopleMainRoleWrapper mt-3 mb-2">
                      <RoleStatus
                        status={
                          userProfile?.fal_information?.specialization
                            ? t(
                                specializationDropdownList?.find(
                                  (obj) =>
                                    obj.value ===
                                    parseInt(
                                      userProfile.fal_information.specialization
                                    )
                                )?.label || "N/A"
                              )
                            : "N/A"
                        }
                      />
                    </Box>
                    <Box className="userProfileAbout mb-2">
                      <SpanStyled
                        size="16px"
                        color="var(--darkGrey)"
                        weight={"bold"}
                      >
                        {userProfile?.personal_information?.about_me}
                      </SpanStyled>
                    </Box>
                    <Box className="userProfileLogos">
                      <CustomTooltip
                        data={{
                          title: t("fal_id"),
                          value: userProfile?.fal_information?.fal_number,
                        }}
                        image={FalLogo}
                      />
                      {userProfile?.fal_information?.mothoq_number && (
                        <CustomTooltip
                          data={{
                            title: t("wothoq_id"),
                            value: userProfile?.fal_information?.mothoq_number,
                          }}
                          image={Mosoq}
                        />
                      )}
                      {/* {UserProfileLogos.map((item, key) => (
                      <span className="userProfileLogo" key={key}>
                        {item.logo}
                      </span>
                    ))} */}
                    </Box>
                  </Box>
                </Col>
                <Col md={12} lg={5} className="socialPropStats">
                  <SocialWrappper>
                    {userProfile?.social_media?.website_url && (
                      <Link
                        to={userProfile?.social_media?.website_url}
                        target="_blank"
                        title={t("website")}
                      >
                        <Globe />
                      </Link>
                    )}
                    {userProfile?.social_media?.youtube_channel_link && (
                      <Link
                        to={userProfile?.social_media?.youtube_channel_link}
                        target="_blank"
                        title={t("youtube")}
                      >
                        <Youtube />
                      </Link>
                    )}
                    {userProfile?.social_media?.linkedin_profile_link && (
                      <Link
                        to={userProfile?.social_media?.linkedin_profile_link}
                        target="_blank"
                        title={t("linkedin")}
                      >
                        <Linkedin />
                      </Link>
                    )}
                    {userProfile?.social_media?.x_profile_link && (
                      <Link
                        to={userProfile?.social_media?.x_profile_link}
                        target="_blank"
                        title={t("x")}
                      >
                        <XSocial />
                      </Link>
                    )}
                    {userProfile?.social_media?.instagram_profile_link && (
                      <Link
                        to={userProfile?.social_media?.instagram_profile_link}
                        target="_blank"
                        title={t("instagram")}
                      >
                        <Instagram />
                      </Link>
                    )}
                    {userProfile?.social_media?.facebook_profile_link && (
                      <Link
                        to={userProfile?.social_media?.facebook_profile_link}
                        target="_blank"
                        title={t("facebook")}
                      >
                        <Facebook width={20} height={20} />
                      </Link>
                    )}
                    {userProfile?.social_media?.one_day_profile_link && (
                      <Link
                        to={userProfile?.social_media?.one_day_profile_link}
                        target="_blank"
                        title={t("one_day")}
                      >
                        <One width={22} height={22} />
                      </Link>
                    )}
                  </SocialWrappper>
                  <PropertiesStatusWrapper>
                    {userProfile?.personal_information?.years_of_experience && (
                      <Box className="propertiesStatusContainer">
                        <Box className="propertiesStatusBox">
                          <Box className="propertiesStatusExperience">
                            <SpanStyled family="var(--bold)" lh="1" size="12px">
                              {
                                userProfile?.personal_information
                                  ?.years_of_experience
                              }
                            </SpanStyled>
                          </Box>
                        </Box>
                        <Box className="propertiesStatusTitleNum">
                          <TextStyled size="14px" lh="1">
                            {t("YearsofExperience")}
                          </TextStyled>
                          <HeadingStyled
                            color="var(--themeColorSecondary)"
                            lh=".7"
                            size="24px"
                          >
                            {
                              userProfile?.personal_information
                                ?.years_of_experience
                            }
                          </HeadingStyled>
                        </Box>
                      </Box>
                    )}
                    {userProfile?.personal_information?.properties_sold && (
                      <Box className="propertiesStatusContainer">
                        <Box className="propertiesStatusBox px-2 text-center">
                          {t("Sold")}
                        </Box>
                        <Box className="propertiesStatusTitleNum">
                          <TextStyled size="14px" lh="1">
                            {t("PropertiesSold")}
                          </TextStyled>
                          <HeadingStyled
                            color="var(--themeColorSecondary)"
                            lh=".7"
                            size="24px"
                          >
                            {userProfile?.personal_information?.properties_sold}
                          </HeadingStyled>
                        </Box>
                      </Box>
                    )}
                  </PropertiesStatusWrapper>
                </Col>
              </Row>
            </UserProfileContentWrapper>
          </ProfileBannerWrapper>
          {!showAll && (
            <ProfileContainer>
              <Box className="profileContainerWrapper">
                <ServicesCities
                  cities={userProfile?.personal_information?.we_operate_in_data}
                  registrationCity={
                    userProfile?.personal_information?.city ||
                    userProfile?.personal_information?.city_name
                  }
                />
                <ProfileContact
                  details={userProfile?.contact_detail}
                  fallbackPhone={userProfile?.phone}
                  fallbackEmail={userProfile?.email}
                />
              </Box>
              <SmBanner>
                <Box className="smBannerInner">
                  <InquiryStatsBanner user={userProfile} />
                </Box>
              </SmBanner>
            </ProfileContainer>
          )}
          <Box>
            <PopertiesListing showAll={showAll} setShowAll={setShowAll} />
          </Box>
          <Box>
            <LookingForListing
              showAll={showAllLookingFor}
              setShowAll={setShowAllLookingFor}
            />
          </Box>
          {isDesktop && (
            <>
              <SmBanner>
                <Box className="smBannerInner" style={{ minHeight: "150px" }}>
                  <LookingFor />
                </Box>
              </SmBanner>
            </>
          )}
        </ProfileWrapper>
      )}
    </>
  );
};

export default MyProfile;
